import React from 'react'
import {connect} from 'react-redux'
import { openModal } from "../actions"

const OpenBtn = ({dispatch, children, btnType, modalName, modalProps = {}}) => {
    return (
        <button 
            className={`btn ${btnType}`} 
            onClick={() => dispatch(openModal(modalName, modalProps))}
        >
            {children}
        </button>
    )
}

const OpenModal = connect(null)(OpenBtn);

export default OpenModal
